import NextButton from './NextButton';

export { NextButton };
export default NextButton;
